import { render, staticRenderFns } from "./MobileNotifications.vue?vue&type=template&id=964c2dca&"
import script from "./MobileNotifications.vue?vue&type=script&lang=js&"
export * from "./MobileNotifications.vue?vue&type=script&lang=js&"
import style0 from "./MobileNotifications.vue?vue&type=style&index=0&id=964c2dca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports